import React, { useEffect, useState } from 'react'
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtils/CommonAxios';
import { config } from '../../../CommonUtils/CommonURLS';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as bie from "react-bootstrap";
import Swal from 'sweetalert2';
import { failureAlert, InfoAlert } from '../../../CommonUtils/SweetAlerts';
import allowNumbersOnly from '../../../CommonUtils/CommonValidations';
import { useSelector } from 'react-redux';
import CommonReactTable from '../../../CommonUtils/CommonReactTable';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { FaFilePdf } from "react-icons/fa6";
import { openPdfInNewTab } from '../../../CommonUtils/CommonServices';

export default function AfflProceedCourseCnfmOamdc({ onNext, setIsSecondTabSubmitted }) {
    const location = useLocation();
    const Collegetype = sessionStorage.getItem('loginType'); // "college" or "ffca" or "university"

    let Type = location?.state?.type;
    const acYear = sessionStorage.getItem('ac_year');
    const CollegeCode = useSelector((state) => state?.commonMastersReducer?.CollegeCode);
    const userId = (sessionStorage.getItem('user_id'))
    const userid = (sessionStorage.getItem('user_id') || "").startsWith('ffca_') ? sessionStorage.getItem('user_id').split('_')[1] : sessionStorage.getItem('user_id');
    const Colcodecondition = userId.startsWith("ffca") ? userid : CollegeCode;
    const ProeedConfirmdetailsFormik = useFormik({
        initialValues: {
            collCode: Colcodecondition,
            acYear: acYear,
            bbaSanctionedIntake: "",
            bcaSanctionedIntake: "",
            ugDetails: [{
                labTypeUg: "",
                crsidUg: "",
                finalIntakeUg: "",
                isLabAvailable: "",
                isFacultyUg: "",
                isApprovalUg: "",
                approvedIntakeUg: "",
                afflType: "",
                afflValidDate: "",

            }],
            pgDetails: [{
                crsidPg: "",
                isFacultyPg: "",
                isApprovalPg: "",
                approvedIntakePg: "",
                isLabAvailablePg: "",
                afflTypePg: "",
                afflValidDatePg: "",
                finalIntakePg: "",
                afflType: "",
            }],
            bbaDetails: [{
                labTypeUg: "",
                crsidUg: "",
                isLabAvailable: "",
                isFacultyUg: "",
                isApprovalUg: "",
                approvedIntakeUg: "",
                finalIntakeUg: "",
                afflType: "",
                afflValidDate: "",


            }],
            aicteBcaDetails: [{
                labTypeUg: "",
                crsidUg: "",
                isLabAvailable: "",
                isFacultyUg: "",
                isApprovalUg: "",
                approvedIntakeUg: "",
                finalIntakeUg: "",
                afflType: "",
                afflValidDate: "",
            }]

        },
        enableReinitialize: true,
        onSubmit: (values) => {
            let payload = {};

            if (values?.ugDetails.length > 0) {
                const validateUgDetails = (ugDetails) => {
                    for (let i = 0; i < ugDetails.length; i++) {
                        const item = ugDetails[i];
                        if (!item.isLabAvailable) {
                            Swal.fire({
                                text: `At UG Details Row ${i + 1}: Please select 'Lab Availability'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }

                        if (!item?.isFacultyUg) {
                            Swal.fire({
                                text: `At UG Details Row ${i + 1}: Please select 'Faculty Availability'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }
                        if (item.isApprovalUg === undefined || item.isApprovalUg === null || item.isApprovalUg === '') {
                            Swal.fire({
                                text: `At UG Details Row ${i + 1}: Please select 'Approval Status'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }


                        if (item.isApprovalUg === "Yes") {
                            // Validate finalIntakeUg
                            if (!item.approvedIntakeUg || isNaN(item.approvedIntakeUg) || item.approvedIntakeUg <= 0) {
                                Swal.fire({
                                    text: `At UG Details Row ${i + 1}: Please enter a valid 'Final Intake'`,
                                    icon: 'error',
                                    backdrop: false
                                });
                                return false;
                            }

                            // Validate afflType
                            if (!item.afflType) {
                                Swal.fire({
                                    text: `At UG Details Row ${i + 1}: Please select 'Affiliation Type'`,
                                    icon: 'error',
                                    backdrop: false
                                });
                                return false;
                            }

                            // Validate afflValidDate
                            // if (!item.afflValidDate) {
                            if (!userId.startsWith("ffca") && !item.afflValidDate) {

                                Swal.fire({
                                    text: `At UG Details Table Row ${i + 1}: Please fill out 'Affiliation Valid Date'`,
                                    icon: 'error',
                                    backdrop: false
                                });
                                return false;
                            }
                        }
                    }
                    return true;
                };



                if (oamdcCourses?.ugCnfDetails?.length > 0) {
                    if (!validateUgDetails(values?.ugDetails)) {
                        return;
                    }
                } else {
                    payload.ugDetails = [];

                    console.log("No UG Courses to validate.");
                }

            }
            const ValidatePgDetails = (pgDetails) => {
                for (let i = 0; i < pgDetails.length; i++) {
                    const item = pgDetails[i];
                    if (!item.isLabAvailablePg) {
                        Swal.fire({
                            text: `At PG Courses Row ${i + 1}: Please select 'Lab Availability'`,
                            icon: 'error',
                            backdrop: false
                        });
                        return false;
                    }

                    if (!item?.isFacultyPg) {
                        Swal.fire({
                            text: `At PG Courses Row ${i + 1}: Please select 'Faculty Availability'`,
                            icon: 'error',
                            backdrop: false
                        });
                        return false;
                    }

                    if (item.isApprovalPg === undefined || item.isApprovalPg === null || item.isApprovalPg === '') {
                        Swal.fire({
                            text: `At PG Courses Row ${i + 1}: Please select 'Approval Status'`,
                            icon: 'error',
                            backdrop: false
                        });
                        return false;
                    }

                    if (item.isApprovalPg === "Yes") {
                        // Validate finalIntakeUg
                        if (!item.approvedIntakePg || isNaN(item.approvedIntakePg) || item.approvedIntakePg <= 0) {
                            Swal.fire({
                                text: `At PG Courses Row ${i + 1}: Please enter a valid 'Approved Final Intake'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }

                        // Validate afflType
                        if (!item.afflTypePg) {
                            Swal.fire({
                                text: `At PG Courses Row ${i + 1}: Please select 'Affiliation Type'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }

                        // Validate afflValidDate
                        // if (!item.afflValidDatePg) {
                        if (!userId.startsWith("ffca") && !item.afflValidDatePg) {

                            Swal.fire({
                                text: `At PG Courses Table Row ${i + 1}: Please fill out 'Affiliation Valid Date'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }
                    }
                }
                return true;
            };

            if (oamdcCourses?.pgCnfDetails?.length > 0) {
                if (!ValidatePgDetails(values?.pgDetails)) {
                    return;
                }
            } else {
                console.log("No PG Courses to validate.");
                payload.pgDetails = []; // Empty array if no PG courses


            }


            ///bba and bca details
            //   {(!userId.startsWith("ffca")&&(<>
            const validateAciteUgBBADetails = (bbaDetails) => {
                for (let i = 0; i < bbaDetails.length; i++) {
                    const item = bbaDetails[i];
                    if (!item.isLabAvailable) {
                        Swal.fire({
                            text: `At AICTE UG BBA  Courses Row ${i + 1}: Please select 'Lab Availability'`,
                            icon: 'error',
                            backdrop: false
                        });
                        return false;
                    }

                    if (!item?.isFacultyUg) {
                        Swal.fire({
                            text: `At AICTE UG BBA Courses Row ${i + 1}: Please select 'Faculty Availability'`,
                            icon: 'error',
                            backdrop: false
                        });
                        return false;
                    }

                    if (item.isApprovalUg === undefined || item.isApprovalUg === null || item.isApprovalUg === '') {
                        Swal.fire({
                            text: `At AICTE UG BBA Courses Row ${i + 1}: Please select 'Approval Status'`,
                            icon: 'error',
                            backdrop: false
                        });
                        return false;
                    }

                    if (item.isApprovalUg === "Yes") {
                        // Validate finalIntakeUg
                        if (!item.finalIntakeUg || isNaN(item.finalIntakeUg) || item.finalIntakeUg <= 0) {
                            Swal.fire({
                                text: `At AICTE UG BBA Courses Row ${i + 1}: Please enter a valid 'Final Intake'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }

                        // Validate afflType
                        if (!item.afflType) {
                            Swal.fire({
                                text: `At AICTE UG BBA Courses Row ${i + 1}: Please select 'Affiliation Type'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }

                        // Validate afflValidDate
                        if (!item.afflValidDate) {
                            Swal.fire({
                                text: `At AICTE UG BBA Courses Table Row ${i + 1}: Please fill out 'Affiliation Valid Date'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }
                    }
                }
                return true;
            };

            if (oamdcCourses?.aicteBbaDetails?.length > 0 && !userId.startsWith("ffca")) {
                if (!validateAciteUgBBADetails(values?.bbaDetails)) {
                    return;
                }
            } else {
                console.log("No BBA Courses to validate.");
                payload.bbaDetails = [];

            }



            const validateAciteUgBCADetails = (aicteBcaDetails) => {
                for (let i = 0; i < aicteBcaDetails.length; i++) {
                    const item = aicteBcaDetails[i];
                    if (!item.isLabAvailable) {
                        Swal.fire({
                            text: `At AICTE UG BCA Courses Row ${i + 1}: Please select 'Lab Availability'`,
                            icon: 'error',
                            backdrop: false
                        });
                        return false;
                    }

                    if (!item?.isFacultyUg) {
                        Swal.fire({
                            text: `At AICTE UG BCA Courses Row ${i + 1}: Please select 'Faculty Availability'`,
                            icon: 'error',
                            backdrop: false
                        });
                        return false;
                    }

                    if (item.isApprovalUg === undefined || item.isApprovalUg === null || item.isApprovalUg === '') {
                        Swal.fire({
                            text: `At AICTE UG BCA Courses Row ${i + 1}: Please select 'Approval Status'`,
                            icon: 'error',
                            backdrop: false
                        });
                        return false;
                    }

                    if (item.isApprovalUg === "Yes") {
                        // Validate finalIntakeUg
                        if (!item.finalIntakeUg || isNaN(item.finalIntakeUg) || item.finalIntakeUg <= 0) {
                            Swal.fire({
                                text: `At AICTE UG BCA Courses Row ${i + 1}: Please enter a valid 'Final Intake'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }

                        // Validate afflType
                        if (!item.afflType) {
                            Swal.fire({
                                text: `At AICTE UG BCA Courses Row ${i + 1}: Please select 'Affiliation Type'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }

                        // Validate afflValidDate
                        if (!item.afflValidDate) {
                            Swal.fire({
                                text: `At AICTE UG BCA Courses Table Row ${i + 1}: Please fill out 'Affiliation Valid Date'`,
                                icon: 'error',
                                backdrop: false
                            });
                            return false;
                        }
                    }
                }
                return true;
            };



            if (oamdcCourses?.aicteBcaDetails?.length > 0 && !userId.startsWith("ffca")) {
                if (!validateAciteUgBCADetails(values?.aicteBcaDetails)) {
                    return;
                }
            } else {
                payload.aicteBcaDetails = []; // Empty array if no BCA courses

                console.log("No BCA Courses to validate.");
            }


            //convering bcaSanctionedIntake and bbaSanctionedIntake as integer
            values.bbaSanctionedIntake = parseInt(values.bbaSanctionedIntake, 10);
            values.bcaSanctionedIntake = parseInt(values.bcaSanctionedIntake, 10);
            // Check if BBA details exist and if bbaSanctionedIntake is not valid (null, undefined, or empty)
            if (oamdcCourses?.aicteBbaDetails?.length > 0) {
                if (values.bbaSanctionedIntake === null || values.bbaSanctionedIntake === undefined || values.bbaSanctionedIntake === '') {
                    Swal.fire({
                        text: "Please enter a valid 'BBA Sanctioned Intake'.",
                        icon: 'error',
                        backdrop: false
                    });
                    return;
                }
            }
            //if bca Details exist   ask bca sancationed intake not exist dont ask validation
            if (oamdcCourses?.aicteBcaDetails?.length > 0) {
                // if (isNaN(values.bcaSanctionedIntake) || values.bcaSanctionedIntake <= 0) {
                if (values.bcaSanctionedIntake === null || values?.bcaSanctionedIntake === undefined || values?.bcaSanctionedIntake === '') {

                    Swal.fire({
                        text: "Please enter a valid 'BCA Sanctioned Intake'.",
                        icon: 'error',
                        backdrop: false
                    });
                    return;
                }
            }
            //every list making finalIntakeUg as integer if not exist send as 0
            values.ugDetails.forEach((item) => {
                item.finalIntakeUg = item.finalIntakeUg ? parseInt(item.finalIntakeUg, 10) : 0;
            });

            values.bbaDetails.forEach((item) => {
                item.finalIntakeUg = item.finalIntakeUg ? parseInt(item.finalIntakeUg, 10) : 0;
            });

            values.aicteBcaDetails.forEach((item) => {
                item.finalIntakeUg = item.finalIntakeUg ? parseInt(item.finalIntakeUg, 10) : 0;
            });

            //  </>)}
            payload = {
                ...values,
                ugDetails: oamdcCourses?.ugCnfDetails?.length > 0 ? values.ugDetails : [],
                bbaDetails: oamdcCourses?.aicteBbaDetails?.length > 0 && !userId.startsWith("ffca") ? values.bbaDetails : [],
                aicteBcaDetails: oamdcCourses?.aicteBcaDetails?.length > 0 && !userId.startsWith("ffca") ? values.aicteBcaDetails : [],
                pgDetails: oamdcCourses?.pgCnfDetails?.length > 0 ? values.pgDetails : [],
            };

            // Check if BBA details exist before validation

            if (oamdcCourses?.aicteBbaDetails?.length > 0 && Collegetype !== "ffca") {
                const totalRecommendedBBA = values.bbaDetails.reduce(
                    (sum, current) => sum + (parseInt(current.approvedIntakeUg) || 0),
                    0
                );

                if (totalRecommendedBBA > values.bbaSanctionedIntake) {
                    Swal.fire({
                        text: `Total approved intake for BBA (${totalRecommendedBBA}) cannot be greater than the BBA sanctioned intake (${values.bbaSanctionedIntake}). Please adjust.`,
                        icon: 'warning',
                        confirmButtonText: 'OK',
                        backdrop: false,
                    });
                    return;
                }
            }
            // Check if BCA details exist before validation

            if (oamdcCourses?.aicteBcaDetails?.length > 0 && Collegetype !== "ffca") {
                const totalRecommendedBCA = values.aicteBcaDetails.reduce(
                    (sum, current) => sum + (parseInt(current.approvedIntakeUg) || 0),
                    0
                );

                if (totalRecommendedBCA > values.bcaSanctionedIntake) {
                    Swal.fire({
                        text: `Total approved intake for BCA (${totalRecommendedBCA}) cannot be greater than the BCA sanctioned intake (${values.bcaSanctionedIntake}). Please adjust.`,
                        icon: 'warning',
                        confirmButtonText: 'OK',
                        backdrop: false,
                    });
                    return;
                }
            }

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveOamdcCdcConfirm`;
                    CommonAxiosPost(url, payload).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire({
                                title: res?.data?.sdesc,
                                backdrop: false
                            }).then(() => {
                                GetOamdcCourses();
                                onNext(Type);
                                setIsSecondTabSubmitted(true);

                            });
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });
        }
    })
    const [oamdcCourses, setOamdcCourses] = useState([]);

    function GetOamdcCourses() {
        let url = config.url.API_URL + `getOamdcCourses/` + Colcodecondition + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res?.data) {
                setOamdcCourses(res?.data)
                ProeedConfirmdetailsFormik?.setFieldValue("bbaSanctionedIntake", res?.data?.honourIntakes[0]?.bba_courses_total_intake === null ? 0 : res?.data?.honourIntakes[0]?.bba_courses_total_intake);
                ProeedConfirmdetailsFormik?.setFieldValue("bcaSanctionedIntake", res?.data?.honourIntakes[0]?.bca_courses_total_intake === null ? 0 : res?.data?.honourIntakes[0]?.bca_courses_total_intake);
                res?.data?.ugCnfDetails?.forEach((data, i) => {
                    const UgDate = data?.affl_valid_date && moment(data?.affl_valid_date,
                        'DD/MM/YYYY', true).isValid() ? moment(data?.affl_valid_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                    ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${i}].crsidUg`, data?.course_id);
                    ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${i}].labTypeUg`, data?.lab_nonlab);
                    ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${i}].finalIntakeUg`, data?.intake);

                    ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${i}].isLabAvailable`, data?.is_lab_availble);
                    ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${i}].isFacultyUg`, data?.is_faculty_ug);
                    ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${i}].isApprovalUg`, data?.is_approval_ug?.toString());
                    ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${i}].approvedIntakeUg`, data?.approved_intake_ug != null ? data?.approved_intake_ug : '');
                    ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${i}].afflType`, data?.affl_type);
                    ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${i}].afflValidDate`, UgDate ?? '');

                });
                res?.data?.aicteBbaDetails?.forEach((data, i) => {
                    const BBADate = data?.affl_valid_date && moment(data?.affl_valid_date,
                        'DD/MM/YYYY', true).isValid() ? moment(data?.affl_valid_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                    ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${i}].crsidUg`, data?.course_cdc);
                    ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${i}].labTypeUg`, data?.lab_nonlab);
                    ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${i}].finalIntakeUg`, data?.intake);

                    ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${i}].isLabAvailable`, data?.is_lab_availble);
                    ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${i}].isFacultyUg`, data?.is_faculty_ug);
                    ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${i}].isApprovalUg`, data?.is_approval_cdc?.toString());
                    ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${i}].approvedIntakeUg`, data?.approved_intake_ug);
                    ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${i}].afflType`, data?.affl_type);
                    ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${i}].afflValidDate`, BBADate ?? '');

                });
                res?.data?.aicteBcaDetails?.forEach((data, i) => {

                    const BCADate = data?.affl_valid_date && moment(data?.affl_valid_date,
                        'DD/MM/YYYY', true).isValid() ? moment(data?.affl_valid_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                    ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${i}].crsidUg`, data?.course_cdc);
                    ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${i}].labTypeUg`, data?.lab_nonlab);
                    ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${i}].finalIntakeUg`, data?.intake);
                    ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${i}].isLabAvailable`, data?.is_lab_availble);
                    ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${i}].isFacultyUg`, data?.is_faculty_ug);
                    ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${i}].isApprovalUg`, data?.is_approval_cdc?.toString());
                    ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${i}].approvedIntakeUg`, data?.approved_intake_ug);
                    ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${i}].afflType`, data?.affl_type);
                    ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${i}].afflValidDate`, BCADate ?? '');

                });

                res?.data?.pgCnfDetails?.forEach((data, i) => {
                    const PGDATE = data?.affl_valid_date_pg && moment(data?.affl_valid_date_pg,
                        'DD/MM/YYYY', true).isValid() ? moment(data?.affl_valid_date_pg, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                    ProeedConfirmdetailsFormik?.setFieldValue(`pgDetails[${i}].crsidPg`, data?.course_id);
                    ProeedConfirmdetailsFormik?.setFieldValue(`pgDetails[${i}].finalIntakePg`, data?.intake);
                    ProeedConfirmdetailsFormik?.setFieldValue(`pgDetails[${i}].isLabAvailablePg`, data?.is_lab_availble_pg);
                    ProeedConfirmdetailsFormik?.setFieldValue(`pgDetails[${i}].isFacultyPg`, data?.is_faculty_pg);
                    ProeedConfirmdetailsFormik?.setFieldValue(`pgDetails[${i}].isApprovalPg`, data?.is_approval_pg?.toString());
                    ProeedConfirmdetailsFormik?.setFieldValue(`pgDetails[${i}].approvedIntakePg`, data?.approved_intake_pg);
                    ProeedConfirmdetailsFormik?.setFieldValue(`pgDetails[${i}].afflTypePg`, data?.affl_type_pg);
                    ProeedConfirmdetailsFormik?.setFieldValue(`pgDetails[${i}].afflValidDatePg`, PGDATE ?? '');

                });
            } else {
                setOamdcCourses([])

            }
        })
    }

    const [ffcaData, SetFfacaData] = useState([]);
    const [ffcaDataFlag, SetFfacaDataFlag] = useState(false);
    async function FFCACourseConfirmedData() {
        let url = config.url.API_URL + `ffcaCnfrmCourses/` + Colcodecondition + "/" + acYear;
        const res = await CommonAxiosGet(url);
        // CommonAxiosGet(url).then((res) => {
        if (res?.data?.status === true) {
            SetFfacaData(res?.data)
            SetFfacaDataFlag(true);
        } else {
            SetFfacaData([])
        }
        // })
    }

    const [omdcstatus, setOmdcstatus] = useState('');

    async function GetOamdcStatusData() {
        let url = config.url.API_URL + `ffcaStatus/` + Colcodecondition + "/" + acYear;
        const res = await CommonAxiosGet(url);
        if (res?.data?.status === true) {
            const statuscondition = res?.data?.ffcaStatus || ''
            setOmdcstatus(statuscondition);

        } else {
            setOmdcstatus('');

        }
    }



    function GetFacultyDefPDf() {
        let url = config.url.API_URL + `getafflfacultydef/pdf/` + userid + "/" + acYear;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === 1) {
                openPdfInNewTab(res?.data?.data)
            } else {
                console.log("No Data Found")

            }
        })
    }
    useEffect(() => {
        FFCACourseConfirmedData();
        GetOamdcStatusData();
        GetOamdcCourses();
    }, [])





    function ValidateBBA(value, index, intake, type) {
        const intakebba = ProeedConfirmdetailsFormik?.values?.bbaSanctionedIntake;
        if (type === "FinalIntake") {
            if (value > intakebba) {
                Swal.fire({
                    text: 'Intake should not be greater than BBA Intake',
                    icon: 'info',
                    confirmButtonText: 'OK',
                    backdrop: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        ProeedConfirmdetailsFormik.setFieldValue("bbaSanctionedIntake", '');
                    }
                });
            }
            const totalRecommended = ProeedConfirmdetailsFormik?.values?.bbaDetails.reduce((sum, current) => sum + (parseInt(current.approvedIntakeUg) || 0), 0);
            if (intakebba < totalRecommended) {
                Swal.fire({
                    text: `${intakebba} is less than sum of Intake being recommended by CDC Dean value ${totalRecommended} please adjust the intake values.`,
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    backdrop: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        ProeedConfirmdetailsFormik.setFieldValue("bbaSanctionedIntake", '');
                    }
                });
            }
        }

        else if (type === "Table") {
            if (value > intake) {
                InfoAlert("Intake for BBA shall not be greater than Intake Sanctioned by CHE");
                ProeedConfirmdetailsFormik.setFieldValue(`bbaDetails[${index}].approvedIntakeUg`, '');
            }
            const totalRecommended = ProeedConfirmdetailsFormik?.values?.bbaDetails.reduce((sum, current) => sum + (parseInt(current.approvedIntakeUg) || 0), 0);
            if (!intakebba || intakebba === '') {
                Swal.fire({
                    text: 'Please enter the BBA Intake',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    backdrop: false,
                }).then(() => {
                    ProeedConfirmdetailsFormik.setFieldValue(`bbaDetails[${index}].approvedIntakeUg`, '');
                });
                return;
            }
            if (totalRecommended > intakebba) {
                InfoAlert("Total  Intake being recommended by CDC Dean shall not be greater than Sanctioned Intake for BBA ");
                ProeedConfirmdetailsFormik.setFieldValue(`bbaDetails[${index}].approvedIntakeUg`, '');
            }
        }
    }

    function ValidateBCA(value, index, intake, type) {
        const intakebca = ProeedConfirmdetailsFormik?.values?.bcaSanctionedIntake;
        if (type === "FinalIntake") {
            if (value > intakebca) {
                Swal.fire({
                    text: 'Intake should not be greater than BCA Intake',
                    icon: 'info',
                    confirmButtonText: 'OK',
                    backdrop: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        ProeedConfirmdetailsFormik.setFieldValue("bcaSanctionedIntake", '');
                    }
                });
            }
            const totalRecommended = ProeedConfirmdetailsFormik?.values?.aicteBcaDetails.reduce((sum, current) => sum + (parseInt(current.approvedIntakeUg) || 0), 0);
            if (intakebca < totalRecommended) {
                Swal.fire({
                    text: `${intakebca} is less than sum of Intake being recommended by CDC Dean value ${totalRecommended} please adjust the intake values.`,
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    backdrop: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        ProeedConfirmdetailsFormik.setFieldValue("bcaSanctionedIntake", '');
                    }
                });
            }
        }

        else if (type === "Table") {
            if (value > intake) {
                InfoAlert("Intake for BCA shall not be greater than Intake Sanctioned by CHE");
                ProeedConfirmdetailsFormik.setFieldValue(`aicteBcaDetails[${index}].approvedIntakeUg`, '');
            }
            const totalRecommended = ProeedConfirmdetailsFormik?.values?.aicteBcaDetails.reduce((sum, current) => sum + (parseInt(current.approvedIntakeUg) || 0), 0);
            if (!intakebca || intakebca === '') {
                Swal.fire({
                    text: 'Please enter the BCA Intake',
                    icon: 'warning',
                    confirmButtonText: 'OK',
                    backdrop: false,
                }).then(() => {
                    ProeedConfirmdetailsFormik.setFieldValue(`aicteBcaDetails[${index}].approvedIntakeUg`, '');
                });
                return;
            }
            if (totalRecommended > intakebca) {
                InfoAlert("Total  Intake being recommended by CDC Dean shall not be greater than Sanctioned Intake for BCA ");
                ProeedConfirmdetailsFormik.setFieldValue(`aicteBcaDetails[${index}].approvedIntakeUg`, '');
            }
        }
    }
    const UGCourseColumns = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, },
        {
            Header: "Academic Program Type ", accessor: "course_group_desc",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Single Major Programme   ", accessor: "course_details",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_details ? row?.values?.course_details : <b style={{ textAlign: 'center' }}>-</b>}</div>


        },
        {
            Header: "Medium", accessor: "medium",


            Cell: ({ row }) => <div>{row?.values?.medium ? row?.values?.medium : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        { Header: <>Intake Sanctioned by CHE</>, accessor: "intake", },
        {
            Header: <>Lab/Non -Lab</>, accessor: "lab_nonlab",


            Cell: ({ row }) => <div>{row?.values?.lab_nonlab ? row?.values?.lab_nonlab : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {

            Header: !userId.startsWith("ffca")
                ? "Is lab available in College for this Single Major Programme as per the Norms of the University"
                : "Is lab available in College for this Single Major Programme as per the Norms of the FFCA",

            accessor: (row, index) => (<>

                <Field as="select" name={`ugDetails[${index}].isLabAvailable`} className="form-control">
                    <option value="">---select----</option>
                    <option value="Available as per the Norms">Available as per the Norms</option>
                    <option value="Not Available as per the Norms">Not Available as per the Norms</option>
                    <option value="Not Required as per the Norms">Not Required as per the Norms</option>
                    <option value="Not Physically Inspected due to shortage of time">Not Physically Inspected due to shortage of time</option>
                </Field>

                <Field type="hidden" name={`ugDetails[${index}].crsidUg`} className="form-control" />
                <Field type="hidden" name={`ugDetails[${index}].labTypeUg`} className="form-control" />
                <Field type="hidden" name={`ugDetails[${index}].finalIntakeUg`} className="form-control" />

            </>),
        },
        {
            Header: !userId.startsWith("ffca")
                ? "Is Faculty available in College for this Single Major Programme with required number and Educational Qualifications as per the Norms of the University"
                : "Is Faculty available in College for this Single Major Programme with required number and Educational Qualifications as per the Norms of the FFCA",
            accessor: (row, index) => (<>
                <Field as="select" name={`ugDetails[${index}].isFacultyUg`} className="form-control">
                    <option value="">---select----</option>
                    <option value="Available as per the Norms" >Available as per the Norms</option>
                    <option value="Not Available as per the Norms">Not Available as per the Norms</option>
                </Field>

            </>),
        },
        {
            Header: !userId.startsWith("ffca")
                ? "Is CDC dean recommending for Affiliation of this Single Major Programme"
                : "Is FFCA recommending for Affiliation of this Single Major Programme",

            accessor: (row, index) => (<>
                <Field as="select" name={`ugDetails[${index}].isApprovalUg`} className="form-control"
                    onChange={e => {
                        ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${index}].approvedIntakeUg`, "");
                        ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${index}].afflType`, "");
                        ProeedConfirmdetailsFormik?.setFieldValue(`ugDetails[${index}].afflValidDate`, "");
                    }}>
                    <option value="">---select----</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>


                </Field>
            </>),
        },

        {
            Header: !userId.startsWith("ffca")
                ? "Intake being recommended by CDC Dean"
                : "Intake being recommended by FFCA",

            accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.ugDetails[index]?.isApprovalUg === "Yes" ?
                    <Field type="text" name={`ugDetails[${index}].approvedIntakeUg`} className="form-control" maxLength="5" onKeyPress={(e) => {
                        allowNumbersOnly(e);
                    }} onChange={(e) => {
                        const recommendedValue = e.target.value;
                        const intakeValue = row.intake;
                        if (parseInt(recommendedValue) > intakeValue) {
                            InfoAlert("Intake being recommended by CDC Dean shall not be greater than Intake Sanctioned by CHE.");
                            e.target.value = '';
                        }
                    }} /> : null}

            </>),
        },

        {
            Header: "Nature of Affilaition", accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.ugDetails[index]?.isApprovalUg === "Yes" ?
                    <Field as="select" name={`ugDetails[${index}].afflType`} className="form-control">
                        <option value="">---select----</option>
                        <option value="Temporary" >Temporary</option>
                        <option value="Conditional">Conditional</option>
                    </Field> : null}
            </>),
        },

        // {
        //     Header: "Affiliation Valid Upto",
        //     accessor: (row, index) => (<>
        //         {ProeedConfirmdetailsFormik?.values?.ugDetails[index]?.isApprovalUg === "Yes" ?
        //             <Field type="date" name={`ugDetails[${index}].afflValidDate`} className="form-control" min={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} />
        //             : null}</>),

        // },


        ...(!userId.startsWith("ffca") ? [{
            Header: "Affiliation Valid Upto",
            accessor: (row, index) => (
                <>
                    {ProeedConfirmdetailsFormik?.values?.ugDetails[index]?.isApprovalUg === "Yes" ? (
                        <Field
                            type="date"
                            name={`ugDetails[${index}].afflValidDate`}
                            className="form-control"
                            min={new Date().toISOString().split('T')[0]}
                            onKeyDown={(e) => { e.preventDefault(); }}
                        />
                    ) : null}
                </>
            )
        }] : [])

    ]



    const PGCourseColumns = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, },
        {
            Header: <> Academic Program Type </>, accessor: "course_group_desc",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Course/Programme", accessor: "course_cat_name",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_cat_name ? row?.values?.course_cat_name : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Branch/Combination", accessor: "course_name",


            Cell: ({ row }) => <div className='text-left'> {row?.values?.course_name ? row?.values?.course_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },

        {
            Header: "Medium", accessor: "medium",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.medium ? row?.values?.medium : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        { Header: <>Intake Sanctioned by CHE </>, accessor: "intake", },

        {
            Header: !userId.startsWith("ffca")
                ? "Is lab available in College for this Course and Specilization as per the Norms of the University"
                : "Is lab available in College for this Course and Specilization as per the Norms of the FFCA",

            accessor: (row, index) => (<>
                <Field as="select" name={`pgDetails[${index}].isLabAvailablePg`} className="form-control">
                    <option value="">---select----</option>
                    <option value="Available as per the Norms">Available as per the Norms</option>
                    <option value="Not Available as per the Norms">Not Available as per the Norms</option>
                    <option value="Not Required as per the Norms">Not Required as per the Norms</option>
                </Field>
                <Field type="hidden" name={`pgDetails[${index}].crsidPg`} className="form-control" />
                <Field type="hidden" name={`pgDetails[${index}].finalIntakePg`} className="form-control" />

            </>),
        },
        {
            Header: !userId.startsWith("ffca")
                ? "Is Faculty available in College for this Course and Specilization with required number and Educational Qualifications as per the Norms of the University"
                : "Is Faculty available in College for this Course and Specilization with required number and Educational Qualifications as per the Norms of the FFCA",

            accessor: (row, index) => (<>
                <Field as="select" name={`pgDetails[${index}].isFacultyPg`} className="form-control">
                    <option value="">---select----</option>
                    <option value="Available as per the Norms" >Available as per the Norms</option>
                    <option value="Not Available as per the Norms">Not Available as per the Norms</option>
                </Field>
            </>),
        },
        {
            Header: !userId.startsWith("ffca")
                ? "Is CDC dean recommending for Affiliation of this Course and Specilization"
                : "Is FFCA recommending for Affiliation of this Course and Specilization",

            accessor: (row, index) => (<>
                <Field as="select" name={`pgDetails[${index}].isApprovalPg`} className="form-control"
                    onChange={e => {
                        ProeedConfirmdetailsFormik?.setFieldValue(`pgDetails[${index}].approvedIntakePg`, "");
                        ProeedConfirmdetailsFormik?.setFieldValue(`pgDetails[${index}].afflTypePg`, "");
                        ProeedConfirmdetailsFormik?.setFieldValue(`pgDetails[${index}].afflValidDatePg`, "");
                    }}>
                    <option value="">---select----</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>

                </Field>
            </>),
        },

        {
            Header: !userId.startsWith("ffca")
                ? "Intake being recommended by CDC Dean"
                : "Intake being recommended by FFCA",

            accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.pgDetails[index]?.isApprovalPg === "Yes" ?
                    <Field type="text" name={`pgDetails[${index}].approvedIntakePg`} className="form-control" maxLength="6" onKeyPress={(e) => {
                        allowNumbersOnly(e);
                    }} onChange={(e) => {
                        const recommendedValue = e.target.value;
                        const intakeValue = row.intake;
                        if (parseInt(recommendedValue) > intakeValue) {
                            InfoAlert("Intake being recommended by CDC Dean shall not be greater than Intake Sanctioned by CHE.");
                            e.target.value = '';
                        }
                    }} /> : null}
            </>),
        },

        {
            Header: "Nature of Affilaition  ",
            accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.pgDetails[index]?.isApprovalPg === "Yes" ?
                    <Field as="select" name={`pgDetails[${index}].afflTypePg`} className="form-control">
                        <option value="">---select----</option>
                        <option value="Temporary">Temporary</option>
                        <option value="Conditional">Conditional</option>
                    </Field> : null}

            </>),
        },

        ...(!userId.startsWith("ffca") ? [{
            Header: "Affiliation Valid Upto",
            accessor: (row, index) => (
                <>
                    {ProeedConfirmdetailsFormik?.values?.pgDetails[index]?.isApprovalPg === "Yes" ? (
                        <Field
                            type="date"
                            name={`pgDetails[${index}].afflValidDatePg`}
                            className="form-control"
                            min={new Date().toISOString().split('T')[0]}
                            onKeyDown={(e) => { e.preventDefault(); }}
                        />
                    ) : null}
                </>
            )
        }] : [])

    ]
    const AciteBBACourseColumns = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, },
        {
            Header: "Academic Program Type", accessor: "course_group_desc",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: "Single Major Programme   ", accessor: "course_details",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_details ? row?.values?.course_details : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },

        {
            Header: "Medium", accessor: "medium_name",


            Cell: ({ row }) => <div>{row?.values?.medium_name ? row?.values?.medium_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        { Header: "Intake Sanctioned by CHE", accessor: "intake", },
        {
            Header: <>Lab/Non -Lab</>, accessor: "lab_nonlab",


            Cell: ({ row }) => <div>{row?.values?.lab_nonlab ? row?.values?.lab_nonlab : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Is lab available in College for this Single Major Programme as per theNorms of the University",
            accessor: (row, index) => (<>
                <Field as="select" name={`bbaDetails[${index}].isLabAvailable`} className="form-control">
                    <option value="">---select----</option>
                    <option value="Available as per the Norms" >Available as per the Norms</option>
                    <option value="Not Available as per the Norms">Not Available as per the Norms</option>
                    <option value="Not Required as per the Norms">Not Required as per the Norms</option>
                    <option value="Not Physically Inspected due to shortage of time">Not Physically Inspected due to shortage of time</option>
                </Field>
                <Field type="hidden" name={`bbaDetails[${index}].crsidUg`} className="form-control" />
                <Field type="hidden" name={`bbaDetails[${index}].labTypeUg`} className="form-control" />
                <Field type="hidden" name={`bbaDetails[${index}].approvedIntakeUg`} className="form-control" />

            </>),
        },
        {
            Header: "Is Faculty available in College for this Single Major Programme with required number and Educational Qualifications as per the Norms of the University",
            accessor: (row, index) => (<>
                <Field as="select" name={`bbaDetails[${index}].isFacultyUg`} className="form-control">
                    <option value="">---select----</option>
                    <option value="Available as per the Norms" >Available as per the Norms</option>
                    <option value="Not Available as per the Norms">Not Available as per the Norms</option>
                </Field>
            </>),
        },
        {
            Header: "Is CDC dean recommending for Affiliation of this Single Major Programme",
            accessor: (row, index) => (<>
                <Field as="select" name={`bbaDetails[${index}].isApprovalUg`} className="form-control"
                    onChange={e => {
                        ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${index}].approvedIntakeUg`, "");
                        ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${index}].afflType`, "");
                        ProeedConfirmdetailsFormik?.setFieldValue(`bbaDetails[${index}].afflValidDate`, "");
                    }}>
                    <option value="">---select----</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </Field>
            </>),
        },

        {
            Header: "Intake being recommended by CDC Dean", accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.bbaDetails[index]?.isApprovalUg === "Yes" ?
                    <Field type="text" name={`bbaDetails[${index}].approvedIntakeUg`} className="form-control" maxLength="6" onKeyPress={(e) => { allowNumbersOnly(e); }}
                        onKeyUp={(e) => {
                            ValidateBBA(e?.target.value, index, row?.intake, "Table")
                        }} /> : null}</>),
        },

        {
            Header: "Nature of Affilaition", accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.bbaDetails[index]?.isApprovalUg === "Yes" ?

                    <Field as="select" name={`bbaDetails[${index}].afflType`} className="form-control">
                        <option value="">---select----</option>
                        <option value="Temporary" >Temporary</option>
                        <option value="Conditional">Conditional</option>
                    </Field>
                    : null}
            </>),
        },
        {
            Header: "Affiliation Valid Upto", accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.bbaDetails[index]?.isApprovalUg === "Yes" ?
                    <Field type="date" name={`bbaDetails[${index}].afflValidDate`} className="form-control" min={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} /> : null} </>),

        },

    ]


    const AciteBCACoursesColumns = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, showFooter: "true" },
        {
            Header: "Academic Program Type", accessor: "course_group_desc",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>


        },
        {
            Header: "Single Major Programme   ", accessor: "course_details",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_details ? row?.values?.course_details : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: "Medium", accessor: "medium_name",


            Cell: ({ row }) => <div>{row?.values?.medium_name ? row?.values?.medium_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        { Header: <>Intake Sanctioned by CHE</>, accessor: "intake", },
        {
            Header: <>Lab/Non -Lab</>, accessor: "lab_nonlab",


            Cell: ({ row }) => <div>{row?.values?.lab_nonlab ? row?.values?.lab_nonlab : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Is lab available in College for this Single Major Programme as per theNorms of the University",
            accessor: (row, index) => (<>
                <Field as="select" name={`aicteBcaDetails[${index}].isLabAvailable`} className="form-control">
                    <option value="">---select----</option>
                    <option value="Available as per the Norms" >Available as per the Norms</option>
                    <option value="Not Available as per the Norms">Not Available as per the Norms</option>
                    <option value="Not Required as per the Norms">Not Required as per the Norms</option>
                    <option value="Not Physically Inspected due to shortage of time">Not Physically Inspected due to shortage of time</option>
                </Field>
                <Field type="hidden" name={`aicteBcaDetails[${index}].crsidUg`} className="form-control" />
                <Field type="hidden" name={`aicteBcaDetails[${index}].labTypeUg`} className="form-control" />
                <Field type="hidden" name={`aicteBcaDetails[${index}].finalIntakeUg`} className="form-control" />

            </>),
        },
        {
            Header: "Is Faculty available in College for this Single Major Programme with required number and Educational Qualifications as per the Norms of the University",
            accessor: (row, index) => (<>
                <Field as="select" name={`aicteBcaDetails[${index}].isFacultyUg`} className="form-control">
                    <option value="">---select----</option>
                    <option value="Available as per the Norms" >Available as per the Norms</option>
                    <option value="Not Available as per the Norms">Not Available as per the Norms</option>
                </Field>
            </>),
        },
        {
            Header: "Is CDC dean recommending for Affiliation of this Single Major Programme",
            accessor: (row, index) => (<>
                <Field as="select" name={`aicteBcaDetails[${index}].isApprovalUg`} className="form-control"
                    onChange={e => {
                        ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${index}].approvedIntakeUg`, "");
                        ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${index}].afflType`, "");
                        ProeedConfirmdetailsFormik?.setFieldValue(`aicteBcaDetails[${index}].afflValidDate`, "");
                    }}>
                    <option value="">---select----</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>

                </Field>
            </>),
        },

        {
            Header: "Intake being recommended by CDC Dean",
            accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.aicteBcaDetails[index]?.isApprovalUg === "Yes" ?
                    <Field type="text" name={`aicteBcaDetails[${index}].approvedIntakeUg`} className="form-control" maxLength="6" onKeyPress={(e) => { allowNumbersOnly(e); }}

                        onKeyUp={(e) => {
                            ValidateBCA(e?.target.value, index, row?.intake, "Table")
                        }}
                    /> : null}
            </>),
        },

        {
            Header: "Nature of Affilaition", accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.aicteBcaDetails[index]?.isApprovalUg === "Yes" ?
                    <Field as="select" name={`aicteBcaDetails[${index}].afflType`} className="form-control">
                        <option value="">---select----</option>
                        <option value="Temporary" >Temporary</option>
                        <option value="Conditional">Conditional</option>
                    </Field>
                    : null}

            </>),
        },
        {
            Header: "Affiliation Valid Upto", accessor: (row, index) => (<>
                {ProeedConfirmdetailsFormik?.values?.aicteBcaDetails[index]?.isApprovalUg === "Yes" ?
                    <Field type="date" name={`aicteBcaDetails[${index}].afflValidDate`} className="form-control" min={new Date().toISOString().split('T')[0]} onKeyDown={(e) => { e.preventDefault() }} /> : null}</>),
        },
    ]
    const UGCourseColumnsFFCA = [
        { Header: "Sl.No", accessor: (row, index) => index + 1, },
        {
            Header: "Academic Program Type ", accessor: "course_group_desc",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Single Major Programme   ", accessor: "course_details",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_details ? row?.values?.course_details : <b style={{ textAlign: 'center' }}>-</b>}</div>


        },
        {
            Header: "Medium", accessor: "medium",


            Cell: ({ row }) => <div>{row?.values?.medium ? row?.values?.medium : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },


        { Header: <>Intake Sanctioned by CHE</>, accessor: "intake", },


        {
            Header: <>Lab/Non -Lab</>, accessor: "lab_nonlab",


            Cell: ({ row }) => <div>{row?.values?.lab_nonlab ? row?.values?.lab_nonlab : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },

        {

            Header: "Is lab available in College for this Single Major Programme as per the Norms of the FFCA",

            accessor: "is_lab_availble",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.is_lab_availble ? row?.values?.is_lab_availble : <b style={{ textAlign: 'left' }}>-</b>}</div>

        },

        {
            Header: "Is Faculty available in College for this Single Major Programme with required number and Educational Qualifications as per the Norms of the FFCA",
            accessor: "is_faculty_ug",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.is_faculty_ug ? row?.values?.is_faculty_ug : <b style={{ textAlign: 'left' }}>-</b>}</div>


        },
        {
            Header: "Is FFCA recommending for Affiliation of this Single Major Programme",
            accessor: "is_approval_ug",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.is_approval_ug ? row?.values?.is_approval_ug : <b style={{ textAlign: 'left' }}>-</b>}</div>



        },

        {
            Header: "Intake being recommended by FFCA",
            accessor: "approved_intake_ug",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.approved_intake_ug ? row?.values?.approved_intake_ug : <b style={{ textAlign: 'left' }}>-</b>}</div>



        },

        {
            Header: "Nature of Affilaition",
            accessor: "affl_type",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.affl_type ? row?.values?.affl_type : <b style={{ textAlign: 'left' }}>-</b>}</div>


        },

    ]



    const PGCourseColumnsFFCA = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, },
        {
            Header: <> Academic Program Type </>, accessor: "course_group_desc",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_group_desc ? row?.values?.course_group_desc : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Course/Programme", accessor: "course_cat_name",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.course_cat_name ? row?.values?.course_cat_name : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Branch/Combination", accessor: "course_name",


            Cell: ({ row }) => <div className='text-left'> {row?.values?.course_name ? row?.values?.course_name : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },

        {
            Header: "Medium", accessor: "medium",


            Cell: ({ row }) => <div className='text-left'>{row?.values?.medium ? row?.values?.medium : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        { Header: <>Intake Sanctioned by CHE </>, accessor: "intake", },

        {
            Header: "Is lab available in College for this Course and Specilization as per the Norms of the FFCA",

            accessor: "is_lab_availble_pg",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.is_lab_availble_pg ? row?.values?.is_lab_availble_pg : <b style={{ textAlign: 'center' }}>-</b>}</div>



        },
        {
            Header: "Is Faculty available in College for this Course and Specilization with required number and Educational Qualifications as per the Norms of the FFCA",

            accessor: "is_faculty_pg",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.is_faculty_pg ? row?.values?.is_faculty_pg : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },
        {
            Header: "Is FFCA recommending for Affiliation of this Course and Specilization",
            accessor: "is_approval_pg",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.is_approval_pg ? row?.values?.is_approval_pg : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: "Intake being recommended by FFCA",
            accessor: "approved_intake_pg",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.approved_intake_pg ? row?.values?.approved_intake_pg : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

        {
            Header: "Nature of Affilaition  ",
            accessor: "affl_type_pg",
            Cell: ({ row }) => <div className='text-left'>{row?.values?.affl_type_pg ? row?.values?.affl_type_pg : <b style={{ textAlign: 'center' }}>-</b>}</div>

        },

    ]
    return (
        <>
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" style={{ backgroundColor: '#FAF7F0' }}>
                <FormikProvider value={ProeedConfirmdetailsFormik}>
                    <Form onChange={ProeedConfirmdetailsFormik?.handleChange} onSubmit={ProeedConfirmdetailsFormik?.handleSubmit} className="form_adjust" >
                        <bie.Row className="px-2 pt-3 mb-3" style={{ border: '0.2px solid black' }}>
                            {/* FFCA REPORT TABLE  UG*/}
                            {ffcaData?.ffcaugList?.length > 0 && ffcaData?.ffcaugList !== "No data found" && !userId.startsWith("ffca") ? (<>
                                <div className="inner-herbpage-service-title-sub-sidemenu pt-4"><h1 className="m-0 p-0 pb-2"> FFCA Commitee  Recommended UG-Courses</h1></div>
                                <div className="table-responsive">
                                    {ffcaDataFlag === true && (<>
                                        <CommonReactTable data={ffcaData?.ffcaugList} columns={UGCourseColumnsFFCA} filename="FFCA Commitee  Recommended UG-Courses" printFlag={false} excelFlag={false} headerName="FFCA Commitee  Recommended UG-Courses" paginationCount='All' />
                                    </>)}
                                </div>
                            </>) : ''}


                            {oamdcCourses?.ugCnfDetails?.length > 0 && oamdcCourses?.ugCnfDetails !== "No data found" ? (<>
                                <div className="inner-herbpage-service-title-sub-sidemenu pt-4"><h1 className="m-0 p-0 pb-2">Affiliation UG Courses</h1></div>
                                <div className="table-responsive">
                                    <CommonReactTable data={oamdcCourses?.ugCnfDetails} columns={UGCourseColumns} filename="Affiliation UG Courses" printFlag={false} excelFlag={false} headerName="Affiliation UG Courses" paginationCount='All' />
                                    {oamdcCourses?.ugCnfDetails?.length > 0 && (<span className="total-intake-message">
                                        Total Sanctioned Intake as Per CHE Course Conversion Order:
                                        {
                                            oamdcCourses.ugCnfDetails.reduce((total, course) => {
                                                return total + (course.intake || 0);
                                            }, 0)
                                        }
                                    </span>
                                    )}

                                </div></>
                            ) : ''}


                            {!userId.startsWith("ffca") && (<>
                                {oamdcCourses?.aicteBbaDetails?.length > 0 && oamdcCourses?.aicteBbaDetails !== "No data found" && (<>
                                    <div className="inner-herbpage-service-title-sub-sidemenu pt-4"><h1 className="m-0 p-0 pb-2"> AICTE UG Courses</h1></div>
                                    <bie.Row>
                                        <div className="row">
                                            <div className="col-4 label">Sanctioned Intake for BBA as per AICTE Order</div>
                                            <div className="col-1">
                                                <Field
                                                    type="text"
                                                    className="form-control"
                                                    name="bbaSanctionedIntake"
                                                    maxLength="6"
                                                    onKeyPress={(e) => { allowNumbersOnly(e); }}
                                                    onBlur={(e) => {
                                                        ValidateBBA(e?.target.value, '', '', "FinalIntake")

                                                    }} />
                                                <ErrorMessage name="bbaSanctionedIntake" component="div" className="text-error" />
                                            </div>
                                        </div>
                                    </bie.Row>
                                    <div className="table-responsive">
                                        {oamdcCourses?.aicteBbaDetails !== "No data found" && (
                                            <CommonReactTable data={oamdcCourses?.aicteBbaDetails} columns={AciteBBACourseColumns} excelFlag={false} printFlag={false} filename="AICTE BBA COURSES" headerName="AICTE BBA COURSES" />
                                        )}
                                        {oamdcCourses?.aicteBbaDetails?.length > 0 && oamdcCourses?.aicteBbaDetails !== "No data found" && (
                                            <span className="total-intake-message">
                                                Total Sanctioned Intake as Per AICTE Approve Order:
                                                {
                                                    oamdcCourses.aicteBbaDetails.reduce((total, course) => {
                                                        return total + (course.intake || 0);
                                                    }, 0)
                                                }
                                            </span>
                                        )}
                                    </div>




                                </>)}

                                {oamdcCourses?.aicteBcaDetails?.length > 0 && oamdcCourses?.aicteBcaDetails !== "No data found" && (<>
                                    <div className="inner-herbpage-service-title-sub-sidemenu pt-4"><h1 className="m-0 p-0 pb-2"> AICTE UG Courses</h1></div>
                                    <bie.Row>
                                        <div className="row">

                                            <div className="col-4 label">Sanctioned Intake for BCA as per AICTE Order   </div>
                                            <div className="col-1">
                                                <Field type="text" className="form-control" name="bcaSanctionedIntake" onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength="6"
                                                    onBlur={(e) => {
                                                        ValidateBCA(e?.target.value, '', '', "FinalIntake")

                                                    }} />
                                                <ErrorMessage name="bcaSanctionedIntake" component="div" className="text-error" />
                                            </div>

                                        </div>
                                    </bie.Row>
                                    <div className="table-responsive">
                                        {oamdcCourses?.aicteBcaDetails !== "No data found" && (
                                            <CommonReactTable data={oamdcCourses?.aicteBcaDetails} columns={AciteBCACoursesColumns} filename="AICTE BCA Courses" excelFlag={false} paginationCount='All' headerName="AICTE BCA Courses" />
                                        )}

                                        {oamdcCourses?.aicteBcaDetails?.length > 0 && oamdcCourses?.aicteBcaDetails !== "No data found" && (<span className="total-intake-message">
                                            Total Sanctioned Intake as Per AICTE Approve Order:
                                            {
                                                oamdcCourses.aicteBcaDetails.reduce((total, course) => {
                                                    return total + (course.intake || 0);
                                                }, 0)
                                            }

                                        </span>
                                        )}
                                    </div>
                                </>)}


                                {/* FFCA REPORT TABLE  FFCA pg  */}
                                {ffcaData?.ffcapgList?.length > 0 && ffcaData?.ffcapgList !== "No data found" ? (<>
                                    <div className="inner-herbpage-service-title-sub-sidemenu pt-4"><h1 className="m-0 p-0 pb-2">FFCA Commitee  Recommended PG-Courses</h1></div>
                                    <div className="table-responsive">
                                        {ffcaDataFlag === true && (<>
                                            <CommonReactTable data={ffcaData?.ffcapgList} columns={PGCourseColumnsFFCA} paginationCount='All' filename="FFCA Commitee  Recommended  PG-Courses" printFlag={false} excelFlag={false} headerName="FFCA Commitee  Recommended  PG-Courses" />

                                        </>)}

                                    </div>
                                </>) : ''}
                            </>)}
                            {oamdcCourses?.pgCnfDetails?.length > 0 && oamdcCourses?.pgCnfDetails !== "No data found" ? (<>
                                <div className="inner-herbpage-service-title-sub-sidemenu pt-4"><h1 className="m-0 p-0 pb-2"> Affiliation PG Courses</h1></div>
                                <div className="table-responsive">
                                    <CommonReactTable data={oamdcCourses?.pgCnfDetails} columns={PGCourseColumns} printFlag={false} paginationCount='All' filename="Affilation PG Courses" excelFlag={false} headerName={`Affiliation Pg Courses`} />
                                </div></>
                            ) : null}
                            {oamdcCourses?.pgCnfDetails?.length > 0 && (<span className="total-intake-message">
                                Total Sanctioned Intake as Per CHE Course Conversion Order:{" "}
                                {
                                    oamdcCourses.pgCnfDetails.reduce((total, course) => {
                                        return total + (course.intake || 0);
                                    }, 0)
                                }
                            </span>
                            )}

                            <div className="button-cend pt-1 mb-3">
                                {(omdcstatus === "0" || userId.startsWith("affl")) && (
                                    <div className="button-cend pt-1 mb-3">
                                        <button type="submit" className="btn btn-success mt-2 me-3 float-end mb-2">
                                            Submit
                                        </button>
                                    </div>
                                )}
                                {omdcstatus == "1" && userId.startsWith("ffca") && (
                                    <button type="button" className='float-end' style={{ color: "brown", fontSize: "20px" }} onClick={GetFacultyDefPDf}>Already Submitted  & view PDF <FaFilePdf size={23} /></button>

                                )}
                            </div>
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container >
        </>
    )
}